<template>
  <v-app :style="appStyle">
    <v-app-bar app dense color="white" clipped-left clipped-right>

      <v-btn icon @click.stop="drawer = !drawer">
        <v-img src="./assets/img/logo-eye-red.svg" width="40"></v-img>
      </v-btn>
      <v-toolbar-title class="d-sm-flex align-items-center d-none" style="min-width:200px;">
        <img alt="Eye On Data Logo" src="./assets/img/logo-name-blue.svg" width="140" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-if="searchbar.show" class="px-4 w-100">
        <eod-search ref="searchbar" v-model="searchbar.filters" flat topbar
          @update="value => $root.$emit('searchUpdated', value)" :config="searchbar.config.search"
          :readonly="searchbar.readonly" :objectType="searchbar.config.objectType"
          :templateType="searchbar.config.searchTemplateType ? searchbar.config.searchTemplateType : 'FILTER'"
          :prependFilterItems="searchbar.prependFilterItems" :defaultFilter="searchbar.defaultFilter"></eod-search>
      </div>
      <v-spacer></v-spacer>
      <eod-time-selector v-if="timeSelector.show" ref="timeSelector" v-model="selectedTime"
        :single-date="timeSelector.singleDate" :arrows="timeSelector.showArrows" :hide-clear="timeSelector.hideClear"
        :fields="timeSelector.fields" :field="timeSelector.field" :no-url-update="timeSelector.noUrlUpdate"
        @update:field="timeSelector.field = $event"
        @input="val => $root.$emit('timeSelectorChanged', val)"></eod-time-selector>
      <v-spacer class="d-block d-sm-none"></v-spacer>
      <v-menu offset-y v-model="isNotificationsMenuVisible" min-width="500" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          
            <v-btn small icon v-bind="attrs" v-on="on" class="ml-2 mr-2">
              <v-badge :content="unreadNotificationsCount" color="red" overlap location="top right" bordered :value="unreadNotificationsCount">
                <v-icon size="20">mdi-bell-outline</v-icon>
              </v-badge>
            </v-btn>
          
        </template>
        <eod-card v-if="isNotificationsMenuVisible" title="Meldingen" icon="mdi-bell-outline">
          <eod-notifications-menu @update="checkNotifications"></eod-notifications-menu>
        </eod-card>
        
      </v-menu>
      <v-menu offset-y
        v-if="$eod.getUser().can('import') || $eod.getUser().can('export') || $eod.getUser().can('organization.settings.create') || $eod.getUser().can('organization.settings.read')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn data-testid="settings-menu-btn" small icon v-bind="attrs" v-on="on" class="mr-2">
            <v-icon  size="20">mdi-cogs</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-if="$eod.getUser().can('import')" @click="showImport = true">
            <v-list-item-icon><v-icon>mdi-database-import</v-icon></v-list-item-icon>
            <v-list-item-title>Importeren</v-list-item-title>
          </v-list-item>
          <v-list-item data-testid="open-export" v-if="$eod.getUser().can('export')" @click="showExport = true">
            <v-list-item-icon><v-icon>mdi-database-export</v-icon></v-list-item-icon>
            <v-list-item-title>Exporteren</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item v-if="$eod.getUser().can('organization.settings.create')" @click="showExportBackup = true">
            <v-list-item-icon><v-icon>mdi-database-export</v-icon></v-list-item-icon>
            <v-list-item-title>Backup</v-list-item-title>
          </v-list-item> -->
          <!-- <v-list-item v-if="$eod.getUser().can('organization.settings.create')" @click="showMessage = true">
            <v-list-item-icon><v-icon>mdi-email-edit-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Bericht versturen</v-list-item-title>
          </v-list-item> -->
          <v-list-item @click="clearCache">
            <v-list-item-icon><v-icon>mdi-cached</v-icon></v-list-item-icon>
            <v-list-item-title>Cache legen</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn small icon @click="showHelp = !showHelp">
        <v-icon size="20">mdi-help-circle-outline</v-icon>
      </v-btn>
      <v-menu offset-y bottom right>
        <template v-slot:activator="{ on, attrs }">
          <v-chip class="pr-6 ml-4" v-bind="attrs" v-on="on" color="primary" style="min-width:150px;">
            <span class="d-block d-sm-none single-line">{{ $eod.getUser().getInitials().toUpperCase() }}</span>
            <span class="d-none d-sm-block single-line">{{ $eod.getUser().getFullName() }}</span>
            <v-icon small right>mdi-chevron-down</v-icon>
          </v-chip>
        </template>
        <v-card>
          <v-list dense>
            <v-list-item v-bind="link_attributes(item)" @click="item.click ? item.click() : null"
              v-for="(item, i) in profile_menu" :key="i">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn @click="reload" icon><v-icon>mdi-refresh</v-icon></v-btn><v-spacer></v-spacer>
            <div>v. {{ version }}</div>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer class="main-navigation-drawer" app v-model="drawer" fixed dark expand-on-hover clipped
      mini-variant>
      <v-list dense flat>
        <template v-for="item in menu">
          <v-list-item v-if="item.heading" :key="item.heading">
            <v-list-item-content>
              <v-list-item-subtitle>{{ item.heading }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <template v-else-if="item.children">
            <v-list-item :key="item.text" :to="item.link">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{ item.text }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon @click="item.model = !item.model" style="transition:.2s all;"
                  :style="item.model ? 'transform:rotate(180deg);' : ''">mdi-chevron-down</v-icon>
              </v-list-item-action>
            </v-list-item>
            <div v-if="item.model" :key="'children_' + item.text" style="background-color:var(--v-primary-lighten2);">
              <v-list-item v-bind="link_attributes(child)" v-for="(child, i) in item.children" :key="i">
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-tooltip bottom v-if="child.tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-content v-bind="attrs" v-on="on">
                      <v-list-item-title>
                        {{ child.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <span>{{ child.tooltip }}</span>
                </v-tooltip>
                <v-list-item-content v-else>
                  <v-list-item-title>
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </template>

          <v-list-item v-bind="link_attributes(item)" v-else :key="item.text">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view :key="$route.fullPath"></router-view>

      <v-footer color="white" elevation="2" fixed padless style="z-index:4;">
        <div class="w-100">
          <div class="w-100 py-1 text-center">
            {{ new Date().getFullYear() }} — <span>powered by</span> <a href="https://www.eyeondata.be/" target="_blank"
              class="text-primary decoration-none"><strong>Eye on Data</strong></a>
          </div>

          <eod-events-drawer-collapse v-if="$eod.getUser().can('events.menu')" />
        </div>

      </v-footer>
    </v-main>

    <v-card v-if="showHelp" id="help" class="d-flex">
      <v-toolbar dense color="primary" dark>
        <v-btn depressed icon @click="showHelp = false"><v-icon>mdi-close</v-icon></v-btn>
        <v-btn depressed icon target="_blank" href="https://docs.eyeondata.eu"><v-icon>mdi-launch</v-icon></v-btn>

      </v-toolbar>
      <div class="flex-grow-1 d-flex">
        <iframe src="https://docs.eyeondata.eu"></iframe>
      </div>
    </v-card>

    <v-dialog v-model="updating" persistent max-width="400">
      <v-card>
        <v-progress-linear color="success" indeterminate></v-progress-linear>
        <v-card-title class="headline">
          <v-avatar color="success" size="40" class="elevation-3 mr-4">
            <v-icon dark>mdi-history</v-icon>
          </v-avatar>
          Updaten
        </v-card-title>
        <v-card-text>
          Eye on Data is aan het updaten...
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="restoring" persistent max-width="400">
      <v-card>
        <v-progress-linear color="success" indeterminate></v-progress-linear>
        <v-card-title class="headline">
          <v-avatar color="success" size="40" class="elevation-3 mr-4">
            <v-icon dark>mdi-backup-restore</v-icon>
          </v-avatar>
          Backup terugzetten
        </v-card-title>
        <v-card-text>
          Eye on Data is bezig met het terugplaatsen van een backup...
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <eod-message-dialog v-if="showMessage" v-model="showMessage"></eod-message-dialog> -->
    <eod-export-dialog v-if="showExport" v-model="showExport" :filters="searchbar.filters" :time-filters="selectedTime"
      :endpoint="(searchbar.config && searchbar.config.itemObject) ? searchbar.config.itemObject.moduleName : null"></eod-export-dialog>
    <eod-import-dialog v-if="showImport" v-model="showImport"></eod-import-dialog>
    <!-- <eod-export-backup-dialog v-if="showExportBackup" v-model="showExportBackup"></eod-export-backup-dialog> -->

    <v-snackbar right top v-model="isCacheSnackbarVisible" rounded="pill" timeout="5000" color="success" @click.native="isCacheSnackbarVisible = false"><v-icon
        left>mdi-cached</v-icon>Cache succesvol geleegd!</v-snackbar>
  </v-app>
</template>
<style lang="scss">
@import './assets/scss/app.scss';
</style>
<script>
import { eodExportDialog, eodImportDialog, eodTimeSelector, eodExportBackupDialog, eodSearch, eodEventsDrawerCollapse, eodNotificationsMenu } from '@/components';
import { filterMenu, getSidebarMenu } from '@/classes/menu';

export default {
  name: 'App',
  components: {
    'eod-export-dialog': eodExportDialog,
    'eod-import-dialog': eodImportDialog,
    'eod-time-selector': eodTimeSelector,
    'eod-export-backup-dialog': eodExportBackupDialog,
    'eod-search': eodSearch,
    eodEventsDrawerCollapse,
    eodNotificationsMenu
  },
  data: () => ({
    drawer: null,
    selectedTime: null,
    showExportBackup: null,
    updating: false,
    restoring: false,
    restoringInterval: null,
    isCacheSnackbarVisible: false,
    timeSelector: {
      show: false,
      singleDate: false,
      showArrows: false,
      hideClear: false,
      fields: [],
      field: null,
      noUrlUpdate: false
    },
    searchbar: {
      show: false,
      readonly: false,
      filters: [],
      defaultFilter: null,
      prependFilterItems: [],
      config: {}
    },
    profile_menu: [],
    menu: [],
    showHelp: false,
    showMessage: false,
    showExport: false,
    showImport: false,
    version: process.env.VUE_APP_VERSION,
    appStyle: '',
    isNotificationsMenuVisible: false,
    unreadNotificationsCount: 0,
  }),
  async mounted() {

    this.getAppStyle();

    let organization = this.$eod.getOrganization();

    const user = this.$eod.getUser();

    this.menu = [
      { heading: organization.description },
      ...getSidebarMenu(user)
    ];

    this.profile_menu = [
      { icon: 'mdi-account', text: 'Mijn profiel', link: { name: 'profile' } },
      {
        icon: 'mdi-bell-outline', text: 'Notificaties', link: { name: 'profile', params: { tab: 'notifications' } }
      },
      {
        icon: 'mdi-logout', text: 'Afmelden', click: () => {
          localStorage.removeItem('eyeondata-user');
          this.$keycloak.logout();
        }
      },
    ];

    this.profile_menu = filterMenu(this.profile_menu);

    this.checkNotifications();
    setInterval(() => {
      this.checkNotifications();
    }, 10000);
  },
  methods: {
    checkNotifications(){
      this.$eod.count('countNotifications', {
        where: [
          {
            column: 'isRead',
            value: '0'
          }
        ]
      }).then(response => {
        if(response?.data?.data?.countNotifications?.totalCount){
          this.unreadNotificationsCount = response.data.data.countNotifications.totalCount;
        } else {
          this.unreadNotificationsCount = 0;
        }
      });
    },
    clearCache() {
      this.$eod.clearCache().then(() => {
        this.isCacheSnackbarVisible = true;
      });
    },
    async getAppStyle() {
      const primary = await this.$eod.getOrganizationSetting('organisation.color.primary');
      const secondary = await this.$eod.getOrganizationSetting('organisation.color.secondary');

      let style = '';
      if (primary && primary.value) {
        style += '--v-primary-base:' + primary.value + ';';
      }

      if (secondary && secondary.value) {
        style += '--v-secondary-base:' + secondary.value + ';';
        style += '--v-secondary-lighten1:' + secondary.value + ';';
      }

      this.appStyle = style;
    },
    reset() {
      this.selectedTime = null;
      this.timeSelector.show = false;
      this.timeSelector.singleDate = false;
      this.timeSelector.hideClear = false;
      this.timeSelector.fields = [];
      this.timeSelector.field = null;
      this.timeSelector.noUrlUpdate = false;

      this.searchbar.show = false;
      this.searchbar.readonly = false;
      this.searchbar.defaultFilter = null;
      this.searchbar.filters = [];
      this.searchbar.config = {};
      this.searchbar.prependFilterItems = [];
    },
    async setRestoring(isRestoring) {
      this.restoring = isRestoring;

      if (isRestoring) {
        if (this.restoringInterval) {
          clearInterval(this.restoringInterval);
        }

        this.restoringInterval = setInterval(async () => {
          await this.$eod.loadUserOrganization().then(async () => {
            const setting = await this.$eod.getOrganizationSetting('backup.restore.running');
            if (!setting || (setting && setting.value != 1)) {
              await this.setRestoring(false);
            }
          });

        }, 10000);
      } else {
        clearInterval(this.restoringInterval);
      }
    },
    reload() {
      window.location.reload(true);
    },
    link_component(item) {
      if (item.click) {
        return 'div';
      } else if (item.href) {
        return 'a';
      } else {
        return 'v-list-item';
      }
    },
    link_attributes(item) {
      if (item.click) {
        return {
          class: 'v-list-item v-list-item--link theme--light'
        }
      } else if (item.href) {
        return {
          href: item.href,
          class: 'v-list-item v-list-item--link theme--light'
        };
      } else {
        return {
          to: item.link
        };
      }
    }
  }
};
</script>
